import {
  IPasswordRequirements,
  PASSWORD_ERROR_TYPES,
} from '@src/interfaces/password.interfaces';

export const PASSWORD_REQUIREMENTS: IPasswordRequirements = {
  [PASSWORD_ERROR_TYPES.MIN]: {
    message: 'default:changePasswordScreen.characters',
  },
  [PASSWORD_ERROR_TYPES.ONE_UPPERCASE]: {
    message: 'default:changePasswordScreen.uppercase',
  },

  [PASSWORD_ERROR_TYPES.ONE_LOWERCASE]: {
    message: 'default:changePasswordScreen.lowercase',
  },

  [PASSWORD_ERROR_TYPES.ONE_NUMBER]: {
    message: 'default:changePasswordScreen.number',
  },
  [PASSWORD_ERROR_TYPES.ONE_SPECIAL_CHARACTERS]: {
    message: 'createPasswordPage.atLeastSpecialCharacter',
  },
};
